var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useContext } from "react";
import { Provider } from "react-redux";
import store from "@redux/store";
import PmsOrders from "../pages/Features/OrderBook";
import { ESubProductIds, ESubProductNames, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import LobApprovalApp from "./LobApproval";
import { useLocation } from "react-router-dom";
import { ProductOrderContext } from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/ProductOrders/ProductOrdersContext";
var OrderBookApp = function (props) {
    var location = useLocation();
    var showPendingTransaction = useMemo(function () {
        var _a;
        return (_a = location.state) === null || _a === void 0 ? void 0 : _a.showPendingTransaction;
    }, [location.state]);
    var productOrdersContext = useContext(ProductOrderContext);
    var RenderComponents = function () {
        if (productOrdersContext.detailedViewEnabled) {
            switch (showPendingTransaction) {
                case ESubProductNames.AIF:
                    return React.createElement(LobApprovalApp, { subCategoryId: ESubProductIds.AIF });
                case ESubProductNames.PMS:
                    return React.createElement(LobApprovalApp, { subCategoryId: ESubProductIds.PMS });
                default:
                    return (React.createElement(Provider, { store: store },
                        React.createElement(PmsOrders, __assign({}, props))));
            }
        }
        else {
            return (React.createElement(Provider, { store: store },
                React.createElement(PmsOrders, __assign({}, props))));
        }
    };
    return RenderComponents();
};
export default OrderBookApp;
